import request from '../util/request'

export function list() {
  const url = '/appconfig/t/tstorage/list'

  return request.get(url).then((res) => res.data)
}


export function getPageList({ page, size, type, name }) {
  const url = '/appconfig/t/tstorage/page'
  const params = { page, size, type, name }
  return request.get(url, { params }).then((res) => res.data)
}


export function addStorage(data) {
  const url = '/appconfig/t/tstorage/addStorage'
  let formData = new FormData()
  for (let i in data) {
    formData.append(i, data[i])
  }
  return request.post(url, formData).then((res) => res.data)
}


export function updateStorage(data) {
  const url = '/appconfig/t/tstorage/updateStorage'
  let formData = new FormData()
  for (let i in data) {
    formData.append(i, data[i])
  }
  return request.post(url, formData).then((res) => res.data)
}

export function deleteStorage({ id }) {
  const url = '/appconfig/t/tstorage/deleteStorage'
  const data = { id }
  let formData = new FormData()
  for (let i in data) {
    formData.append(i, data[i])
  }
  return request.post(url, formData).then((res) => res.data)
}


